import { FC } from 'react'

import { ResourceHeader } from '@factorialco/f0-react/dist/experimental'
import { PerformanceProcessTargetHeaderFragment } from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'

export const ReviewProcessTargetHeader: FC<{
  target: PerformanceProcessTargetHeaderFragment
}> = ({ target }) => {
  return (
    <ResourceHeader
      title={target?.fullName || ''}
      description={target?.employee?.referenceContract?.jobTitle || ''}
      avatar={{
        src: buildUrl(target?.avatar),
        firstName: target?.firstName || '',
        lastName: target?.lastName || '',
        type: 'person',
      }}
    />
  )
}
